// extracted by mini-css-extract-plugin
module.exports = {"container":"PageEmptyPlaceholder_container__3thc3","verticalAlign":"PageEmptyPlaceholder_verticalAlign__2gUGy","icon":"PageEmptyPlaceholder_icon__vcRCC"};